import { useEffect } from "react";
import { LOGO_URL } from "../data/brand";

export const SITE_URL = "https://www.venpa.co.in";
export const SITE_NAME = "Venpa AI";
// No dedicated 1200x630 share card exists yet — the logo is the closest
// existing asset and is a large improvement over shipping no og:image at
// all. Commissioning a proper share-card graphic is a follow-up (see
// docs/seo-audit/02-technical-seo-implementation.md).
export const DEFAULT_IMAGE = LOGO_URL;

function upsertMeta(attr, key, content) {
  if (!content) return;
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href) {
  if (!href) return;
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * Per-route metadata: title, description, canonical, OpenGraph, Twitter/X
 * card, and robots directives. Every page must render this with a title +
 * description unique to that page's actual content — see the audit
 * (OP-01/OP-02/TS-02/SS-01/SS-02/SS-03) for why the previous single static
 * index.html tag set was a critical defect.
 *
 * This updates the DOM directly (same upsert-by-selector pattern already
 * used by JsonLd.jsx) rather than pulling in react-helmet-async, avoiding a
 * new dependency with uncertain React 19 peer-dep support.
 */
export default function Seo({
  title,
  description,
  path = "/",
  image = DEFAULT_IMAGE,
  type = "website",
  noindex = false,
}) {
  useEffect(() => {
    const url = `${SITE_URL}${path}`;

    document.title = title;
    upsertMeta("name", "description", description);
    upsertLink("canonical", url);

    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:type", type);
    upsertMeta("property", "og:site_name", SITE_NAME);
    upsertMeta("property", "og:locale", "en_US");
    upsertMeta("property", "og:image", image);

    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);
    upsertMeta("name", "twitter:image", image);

    upsertMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");
  }, [title, description, path, image, type, noindex]);

  return null;
}
